<template>
    <div data-box="flie-listview" class="d-flex justify-start">
        <div data-box="file-show" class="d-flex justify-center" v-for="(item, index) in uploadFiles" :key="index" v-if="uploadFiles.length > 0">
            <span class="photo">
                <img :preview="new Date().getTime()" :src="item"/>
            </span>
            <a class="delete" @click.stop="onDelete(item, index)">
                <Icon type="md-close-circle" size="22" color="#FB6463"/>
            </a>
            <Spin fix v-if="loading">
                <Icon type="ios-loading" size="24" class="spin-icon-load"/>
            </Spin>
        </div>
        <Upload data-box="file-select" type="drag" action="" :multiple="size > 1 ? true : false" :accept="accept" :show-upload-list="false" :before-upload="beforeUpload" v-if="uploadFiles.length < size">
            <div style="padding: 29px 0;">
                <Icon type="ios-cloud-upload-outline" size="32"/>
            </div>
        </Upload>
    </div>
</template>

<style type="text/css">
    [data-box="flie-listview"] {
        margin: -6px;
        flex-wrap: wrap !important;
    }

    [data-box="file-show"] {
        width: 96px;
        height: 96px;
        margin: 6px;
    }

    [data-box="file-show"] .photo {
        display: flex;
        display: -webkit-flex;
        position: absolute;
        width: 100%;
        height: 100%;
        left: 0;
        top: 0;
        background: #cacaca;
        border-radius: 4px;
        overflow: hidden;
        justify-content: center;
        -webkit-align-items: center;
        align-items: center;
    }

    [data-box="file-show"] .photo > img {
        max-width: 100%;
        max-height: 100%;
    }

    [data-box="file-show"] .delete {
        display: flex;
        display: -webkit-flex;
        position: absolute;
        top: -9px;
        right: -9px;
        z-index: 10;
        background: #fff;
        border-radius: 50%;
        justify-content: center;
        -webkit-align-items: center;
        align-items: center;
    }
    [data-box="file-show"] .spin-icon-load{
        animation: ani-spin 120s linear infinite;
    }
    @keyframes ani-spin {
        from { transform: rotate(0deg);}
        50%  { transform: rotate(180deg);}
        to   { transform: rotate(360deg);}
    }

    [data-box="file-select"] {
        display: block;
        position: relative;
        width: 96px;
        height: 96px;
        margin: 6px;
    }
    [data-box="file-select"] .ivu-upload {
        width: 96px;
        height: 96px;
    }

    [data-box="file-upload"]{
        display: flex !important;
        display: -webkit-flex !important;;
        position: relative !important;;
        width: 96px;
        height: 96px;
        margin: 6px;
        border-radius: 4px;
        border: 1px dashed #409EFF;
        font-size: 16px;
        background: #fff;
        cursor: pointer;
        justify-content: center !important;;
        -webkit-align-items: center !important;;
        align-items: center !important;;
    }
    [data-box="file-upload"]:hover{
        opacity: .75;
    }
</style>

<script type="text/javascript">
    export default {
        data() {
            return {
                loading: false,
                formData: new FormData(), // 上传数据
                uploadFiles: [], // 回显数据
                uploadReset: false, // 是否删除后重新上传
                accept: 'image/*',
            }
        },
        props: {
            data: Array,
            type: String,
            kind: String,
            size: Number,
        },
        mounted() {
            this.uploadFiles = [];
            if (this.data instanceof Array && this.data.length > 0){
                this.data.forEach(item => {
                    if (item !== ''){
                        this.uploadFiles.push(this.$api.resHttp().target + item);
                    }
                });
            }

            if (this.type === 'image'){
                this.accept = 'image/*';
            } else if (this.type === 'video') {
                this.accept = 'video/*';
            } else if (this.type === 'audio') {
                this.accept = 'audio/*';
            } else {
                this.accept = '';
            }
        },
        methods: {
            async beforeUpload(data) {
                let that = this;
                let files = [];
                files.push(data);
                let reader = new FileReader();

                for(let i = 0; i < files.length; i++){
                    reader.readAsDataURL(files[i]);
                    reader.onload = function () {
                        that.uploadFiles.push(reader.result);
                    };
                    that.formData.append("files", files[i]);
                    that.uploadReset = true;
                }
                this.confirmUpload();

                return false;
            },
            onDelete(data, i) {
                console.log('this.onDelete---------->', data, i);
                this.uploadFiles.splice(i, 1);
                if (this.uploadFiles.length === 0){
                    this.uploadReset = true;
                }
            },
            async confirmUpload(){
                debugger
                if (this.uploadFiles.length > this.size){
                    return this.$Message.error('最多只能上传' + this.length + '个文件');
                }
                this.loading = true;
                let res = await this.$api.postHttp('common/upload', this.formData);
                this.loading = false;
                if (res.data.code !== 0){
                    return this.$Message.error(res.data.msg);
                }
                // this.$Message.success('上传成功');
                let array = res.data.data;
                this.uploadFiles = [];
                array.forEach(item => {
                    this.uploadFiles.push(this.$api.resHttp().target + item.filePath);
                });

                debugger
                if (this.kind === 'logo' || this.kind === 'poster' || this.kind === 'avatar'){
                    this.$emit('change', array[0].filePath, this.kind);
                }
            },
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/Upload.vue